/* eslint-disable react/prop-types */
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import {
  Alert,
  Button,
  Col,
  Input,
  Label,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import Attachment from "./Attachment";
import { useDropzone } from "react-dropzone";
import ContractorBankDetails from "ContractorBankDetails";
import { apiURL } from "redux/action/api";
import { fetchApi } from "redux/action/api_tbeams";
import { postApi } from "redux/action/api_tbeams";
import { useQuery } from "redux/action/api";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import WarningModal from "./WarningModal";
import { formatNumber } from "redux/action/api";
import { useToasts } from "helper/ToastAdapter";
import { getSector } from "helper";
import { getMDaType } from "helper";
import RealiseCollectionPdfWebView from "components/RealiseCollectionPdfWebView";
import SearchBar from "components/SearchBar";

export function getDistinctObjects(array, key1, key2) {
  return array?.filter(
    (obj, index, self) =>
      index ===
      self?.findIndex((o) => o[key1] === obj[key1] && o[key2] === obj[key2]),
  );
}

export default function CapitalProject({ generalForm = {} }) {
  const query = useQuery();
  const mdacode = query.get("mda_code");
  const mdaRef = useRef();
  const ecoRef = useRef();
  const headRef = useRef(); // For MDA Head selection
  const fundRef = useRef(); // For Fund Code
  const functionalRef = useRef(); // For Functional Code
  const programRef = useRef(); // For Program Code
  const geoRef = useRef(); // For Geo Code
  const ccMdaRef = useRef(); // For CC MDA selection
  const navigate = useNavigate();
  const user = useSelector((e) => e.auth.user);

  const [treasuryAccount, setTreasuryAccount] = useState([]);
  const [mdaAccount, setMdaAccount] = useState([]);
  const [budgetSummary, setBudgetSummary] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [balLoanding, setBalLoanding] = useState(false);

  const [showAmountWarningModal, setShowAmountWarningModal] = useState(false);
  const [submittingReserveRequest, setSubmittingReserveRequest] =
    useState(false);

  // List functionality states
  const [approveData, setApproveData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [listMode, setListMode] = useState(false);
  const [listLoading, setListLoading] = useState(false);
  const [childCode, setChildCode] = useState([]);
  const economicTypeahead = useRef();
  const economicTypeahead1 = useRef();
  const [form, setForm] = useState({
    date: moment().format("YYYY-MM-DD"),
    pv_code: "",
    projectType: "",
    paymentType: "",
    paymentClass: "",
    project_type: "",
    other_project_type: "",
    payment_type: "",
    other_payment_type: "",
    payment_class: "",
    mda_name: "",
    destMdaCode: "",
    sourceMdaCode: "",
    mda_code: "",
    mda_budget_balance1: "",
    sourceEconomicCode: "",
    sourceEconomicDescription: "",
    narration: "",
    fund_code: "",
    fund_description: "",
    functional_code: "",
    functional_description: "",
    program_code: "",
    program_description: "",
    geo_code: "",
    geo_description: "",
    contractor_phone: "",
    contractor_tin: "",
    contractor_email: "",
    contractor_address: "",
    account_name: "",
    bank_name: "",
    account_number: "",
    sort_code: "",
    query_type: "insert",
    approved_amount: "",
    reserveType: "",
    reserveStatus: "Pending",
    userId: user.username,
    approval_date: moment().format("YYYY-MM-DD"),
    mda_budget_balance: 0,
    approval_no: "",
    cc_mda_name: "",
    cc_copies: {},
    send_to_mda: "",
    user_id: user.id,
  });

  // Update form with generalForm values when generalForm changes
  useEffect(() => {
    if (generalForm && Object.keys(generalForm).length > 0) {
      setForm((prevForm) => ({
        ...prevForm,
        ...generalForm,
      }));
    }
  }, [generalForm]);

  const [economicCode, setEconomicCode] = useState([]);
  const [economicCode1, setEconomicCode1] = useState([]);
  const [programCode, setProgramCode] = useState([]);
  const [geoCode, setGeoCode] = useState([]);
  const [funcCode, setFuncCode] = useState([]);
  const [fundCode, setFundCode] = useState([]);
  const [admin, setAdmin] = useState([]);
  const [filteredEconomicCode, setFilteredEconomicCode] = useState([]);
  const [distinctAdmins, setDistinctAdminCodes] = useState([]);
  const [fetching, setFetching] = useState(false);

  const getData = (cb, type) => {
    getSector({ type }, "select", (d) => {
      cb(d);
    });
  };

  useEffect(() => {
    getData(setFuncCode, "FUNCTIONAL SEGMENT");
    getData(setProgramCode, "PROGRAMME SEGMENT");
    getData(setGeoCode, "GEO SEGMENT");
    getData(setFundCode, "FUND SEGMENT");
    getData(setAdmin, "ADMINISTRATIVE SEGMENT");
  }, []);

  const [showForm, setShowForm] = useState(true);
  const { addToast } = useToasts();

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } =
    useDropzone({ accept: "image/*, .pdf, text/plain" });

  const getCCCopies = useCallback(() => {
    postApi(`post-cc?query_type=select_mda`, { mda_name: form.mda_name })
      .then((data) => {
        console.log("data", data);
        if (data.results) {
          setForm((p) => ({ ...p, copies: data.results[0] }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [form.mda_name]);

  const getCCCopies1 = useCallback(() => {
    postApi(`post-cc?query_type=select_mda`, { mda_name: form.mda_head })
      .then((data) => {
        console.log("data", data);
        if (data.results) {
          setForm((p) => ({ ...p, copies1: data.results[0] }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [form.mda_head]);

  const getCCCopiesForCC = useCallback(() => {
    if (form.cc_mda_name) {
      postApi(`post-cc?query_type=select_mda`, { mda_name: form.cc_mda_name })
        .then((data) => {
          console.log("CC data", data);
          if (data.results) {
            setForm((p) => ({
              ...p,
              cc_copies: data?.results[0]?.officeTitle,
              cc: data?.results[0]?.officeTitle,
            }));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [form.cc_mda_name]);

  useEffect(() => {
    getCCCopies();
    getCCCopies1();
    getCCCopiesForCC();
  }, [getCCCopies, getCCCopies1, getCCCopiesForCC]);

  const getList = () => {
    getSector({ type: "mdas" }, "mdas", (d) => {
      setBudgetSummary(d);
    });
  };

  useEffect(() => {
    getList();
  }, []);

  // useEffect(() => {
  //   postApi(`select_mda_bank_details`, {
  //     query_type: "select",
  //   }).then((data) => {
  //     if (data.result && data.result.length) {
  //       console.log(data.result);

  //       const treasuryAccount = data.result.filter(
  //         (item) => item.account_type === "treasury_source_account"
  //       );
  //       setTreasuryAccount(treasuryAccount);

  //       const mdaAccount = data.result.filter(
  //         (item) => item.account_type === "mda_source_account"
  //       );
  //       setMdaAccount(mdaAccount);
  //     }
  //   });
  // }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    // Allow '/' for approval_no field without special processing
    if (name === "approval_no") {
      setForm((prevForm) => ({
        ...prevForm,
        [name]: value,
      }));
      return;
    }

    if (typeof value === "string" && value.includes("/")) {
      const [code, description] = value.split("/");

      // Update the form state with code and description separately
      setForm((prevForm) => ({
        ...prevForm,
        [name]: code,
        [`${name}_description`]: description,
      }));
    } else {
      // If the value is not a string or doesn't contain a '/', update the form state normally
      setForm((prevForm) => ({
        ...prevForm,
        [name]: value,
      }));
    }
  };

  const handleChanges = (e) => {
    const { name, type, checked, value } = e.target;
    if (type === "checkbox") {
      setForm((prev) => ({ ...prev, [name]: checked ? value : "" }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleMdaCode = (selected) => {
    if (selected?.length) {
      const selectedItem = selected[0];
      getMDaType(
        {},
        selectedItem.admin_code,
        (d) => {
          setForm((p) => ({ ...p, mda_sn: d[0]?.mda_sn || "" }));
        },
        "select_sn",
      );
      setForm((p) => ({
        ...p,
        mda_head_code: selectedItem.admin_code,
        mda_head: selectedItem.admin_description,
        send_to_office: selectedItem.admin_code,
        // Clear budget values when MDA head changes
        mda_budget_balance: "",
        budget: "",
      }));
    } else {
      console.log("no item selected");
      setForm((p) => ({
        ...p,
        mda_head_code: "",
        mda_head: "",
        send_to_office: "",
        mda_budget_balance: "",
        budget: "",
      }));
    }
  };

  const getList31 = useCallback(() => {
    setBalLoanding(true);
    postApi(`update_budget_balance`, {
      query_type: "select",
      mda_name: form.mda_name,
      mda_code: form.mda_code,
      amount: null,
      economic_code: form.economic_code,
      geo_code: form.geo_code,
      program_code: form.program_code,
      functional_code: form.functional_code,
      fund_code: form.fund_code,
    })
      .then((d) => {
        setBalLoanding(false);
        if (d.success) {
          const selectedItem = d.data[0];
          setForm((p) => ({
            ...p,
            description: selectedItem?.budget_description,
            mda_budget_balance:
              selectedItem?.mopb_balance == 0
                ? "Budget Exausted"
                : selectedItem?.mopb_balance,
            budget:
              selectedItem?.approve_amount == 0
                ? "Budget Exausted"
                : selectedItem?.approve_amount,
          }));
        }
      })
      .catch((err) => {
        setBalLoanding(false);
        console.log(err);
      })
      .finally(() => {
        setBalLoanding(false);
      });
  }, [
    form.projectType,
    form.mda_name,
    form.mda_code,
    form.mda_head_code,
    form.sourceEconomicCode,
    form.geo_code,
    form.program_code,
    form.functional_code,
    form.fund_code,
  ]);

  useEffect(() => {
    getList31();
  }, [getList31]);

  // Update the useEffect to automatically update balance when key values change

  // ...existing code...

  const handleEconomicCode = (selected) => {
    if (selected?.length) {
      const selectedItem = selected[0];
      setNewdata(
        economicCode1?.filter(
          (item) => item.economic_code === selectedItem.economic_code,
        ) || [],
      );
      setForm((p) => ({
        ...p,
        mda_economic_code: selectedItem.economic_code,
        sourceEconomicCode: selectedItem.economic_code,
        sourceEconomicDescription: selectedItem.economic_description,
        description: selectedItem.economic_description,
        economic_code: selectedItem.economic_code,
      }));
    } else {
      console.log("no item selected");
      // Clear budget balance when no economic code is selected
      setForm((p) => ({
        ...p,
        mda_economic_code: "",
        sourceEconomicCode: "",
        sourceEconomicDescription: "",
        description: "",
        economic_code: "",
        mda_budget_balance: "",
        budget: "",
      }));
    }
  };

  const handleMdaCode1 = (selected) => {
    if (selected?.length) {
      const selectedItem = selected[0];

      // Clear all typeahead inputs
      ecoRef.current?.clear();
      headRef.current?.clear();
      fundRef.current?.clear();
      functionalRef.current?.clear();
      programRef.current?.clear();
      geoRef.current?.clear();

      // Filter economicCode based on selected MDA
      const filteredData = economicCode.filter(
        (item) =>
          item.admin_code === selectedItem.admin_code ||
          item.mda_code === selectedItem.admin_code,
      );

      // Set the filtered data for use in other dropdowns
      setFilteredEconomicCode(filteredData);
      getMDaType(
        {},
        selectedItem.admin_code,
        (d) => {
          setForm((p) => ({ ...p, mda_sn: d[0]?.mda_sn || "" }));
        },
        "select_sn",
      );
      setForm((p) => ({
        ...p,
        mda_code: selectedItem.admin_code,
        mda_description: selectedItem.admin_description,
        mda_name: selectedItem.admin_description,
        // Clear all dependent fields when MDA changes
        sourceEconomicCode: "",
        sourceEconomicDescription: "",
        mda_economic_code: "",
        economic_code: "",
        description: "",
        mda_budget_balance: "",
        budget: "",
        fund_code: "",
        fund_description: "",
        functional_code: "",
        functional_description: "",
        program_code: "",
        program_description: "",
        geo_code: "",
        geo_description: "",
        approved_amount: "",
        // Clear MDA head related fields
        mda_head_code: "",
        mda_head: "",
        send_to_office: "",
      }));

      // Remove getList21 call since we're using the filtered data
      // getList21(selectedItem.admin_code);
    } else {
      console.log("no item selected");

      // Clear all typeahead inputs when MDA is deselected
      ecoRef.current?.clear();
      headRef.current?.clear();
      fundRef.current?.clear();
      functionalRef.current?.clear();
      programRef.current?.clear();
      geoRef.current?.clear();

      // Clear filtered data
      setFilteredEconomicCode([]);

      setForm((p) => ({
        ...p,
        mda_code: "",
        mda_description: "",
        mda_name: "",
        mda_sn: "",
        // Clear all dependent fields when MDA is deselected
        sourceEconomicCode: "",
        sourceEconomicDescription: "",
        mda_economic_code: "",
        economic_code: "",
        description: "",
        mda_budget_balance: "",
        budget: "",
        fund_code: "",
        fund_description: "",
        functional_code: "",
        functional_description: "",
        program_code: "",
        program_description: "",
        geo_code: "",
        geo_description: "",
        approved_amount: "",
        // Clear MDA head related fields
        mda_head_code: "",
        mda_head: "",
        send_to_office: "",
      }));
    }
  };

  const [newData, setNewdata] = useState();

  const getList2 = () => {
    setFetching(true);
    fetchApi(`get-budget-summary?query_type=capital`)
      .then((d) => {
        setFetching(false);
        if (d.result) {
          // console.log(d, "ddkdjd");
          setEconomicCode(d.result);
          const distinctAdmins = getDistinctObjects(
            d.result,
            "admin_code",
            "admin_description",
          );
          setDistinctAdminCodes(distinctAdmins);
        }
      })
      .catch((err) => {
        setFetching(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getList2();
  }, []);

  const handleApi = () => {
    console.log(
      "form.approved_amount",
      form.approved_amount,
      "form.mda_budget_balance",
      form.mda_budget_balance,
    );
    if (
      parseFloat(form.approved_amount) > parseFloat(form.mda_budget_balance)
    ) {
      setShowAmountWarningModal(true);
    } else {
      // const formDataWithMultiSelect = {
      //   ...form,
      //   cc: selectedOptions.map((option) => option.value),
      // };
      setIsLoading(true);
      // generalForm.sent_to_mda = generalForm?.sent_to.office || "";
      // generalForm.sent_to_office = generalForm?.sent_to.title || "";
      form.approval_type = "Capital";
      form.approved_by = "HE";
      form.query_type = "insert";
      form.approval_status = "Approval Initiated";
      form.send_to_mda = form.mda_code;
      form.cc = generalForm.cc;
      form.cc_mda_name = generalForm.cc_mda_name;
      postApi(`post_approval_collection`, { form })
        .then((data) => {
          if (data.success) {
            console.log(data);
            handleApi1(form.approval_no);
            // handleSubmitReset();
            addToast("Approval Submitted Successfully!", {
              appearance: "info",
              autoDismiss: true,
              autoDismissTimeout: 5000,
            });
            setShowForm(false);
            // navigate("/release-collection");
          }
        })
        .catch((err) => {
          alert("");
          setIsLoading(false);
          addToast("An error occurred, please try again later.", {
            appearance: "error",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
          setShowForm(false);
        })
        .finally(() => {
          setIsLoading(false);
          setShowForm(false);
        });
    }
  };

  const handleApi1 = () => {
    if (form.approved_amount && form.approved_amount !== "") {
      const formData = new FormData();

      for (let i = 0; i < acceptedFiles.length; i++) {
        formData.append("files", acceptedFiles[i]);
      }

      if (!acceptedFiles.length) {
        setForm((p) => ({ ...p, approval: "not approved" }));
        formData.append("form", JSON.stringify(form));

        fetch(`${apiURL}/post_images`, {
          method: "POST",

          body: formData,
        })
          .then((response) => response.json())
          .then((result) => {
            console.log(result);
          })

          .catch((err) => {
            console.log(err);
          });
      } else {
        formData.append("form", JSON.stringify(form));

        fetch(`${apiURL}/post_images`, {
          method: "POST",

          body: formData,
        })
          .then((response) => response.json())
          .then((result) => {
            console.log(result);
          })

          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      alert("Please enter a valid amount");
    }
  };

  // List functionality functions
  const getCapitalApproveData = useCallback(() => {
    setListLoading(true);
    postApi(`monthly-recurrent?query_type=select`, {
      rec_type: "capital",
    })
      .then((res) => {
        if (res.success) {
          const dataWithDisabledFlag = res.results.map((item) => ({
            ...item,
            ...form,
            mda_description: item.economic_name,
            mda_economic_code: item.economic_code,
            description: item.economic_name,
            mda_code: item.admin_code,
            mda_name: item.admin_name,
            projectType: "capital",
            disabled: false,
          }));
          setApproveData(dataWithDisabledFlag);
        }
        setListLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setListLoading(false);
      });
  }, [form]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleTableChange = (value, id) => {
    const newData = approveData.map((item) =>
      item.id === id ? { ...item, amount: value } : item,
    );
    setApproveData(newData);
  };

  const handleParentCheck = (group) => {
    const newData = approveData.map((item) =>
      item.admin_code === group ? { ...item, disabled: !item.disabled } : item,
    );
    setApproveData(newData);
  };

  const handleChildCheck = (id) => {
    const newData = approveData.map((item) =>
      item.id === id ? { ...item, disabled: !item.disabled } : item,
    );
    setApproveData(newData);
  };

  const handleListSubmit = () => {
    const list = approveData
      .filter(
        (item) =>
          item.disabled === false && item.amount && parseFloat(item.amount) > 0,
      )
      .map((items) => ({
        ...items,
        approved_amount: parseFloat(items.amount) || 0,
        narration: form.narration,
        sent_to_mda: form.sent_to_mda,
        approval_no: form.approval_no,
      }));

    if (list.length === 0) {
      addToast("Please select items and enter amounts before submitting", {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      return;
    }

    setIsLoading(true);
    form.sent_to_mda = form.sent_to?.office || "";
    form.sent_to_office = form.sent_to?.title || "";
    form.projectType = "capital";
    postApi(`post_approval_collection`, { list, form })
      .then((data) => {
        if (data.success) {
          const _newData = approveData
            .map((i) => ({
              ...i,
              approval_no: data.approval_no,
              approved_amount: parseFloat(i.amount) || 0,
            }))
            .filter(
              (item) =>
                item.disabled === false &&
                item.amount &&
                parseFloat(item.amount) > 0,
            );
          setApproveData(_newData);
          addToast("Submit successful", {
            appearance: "success",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
          setShowForm(false);
        }
      })
      .catch((err) => {
        console.log(err);
        addToast("Submission failed", {
          appearance: "error",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const submitPlanningReserveRequest = () => {
    setIsLoading(true);
    // generalForm?.sent_to_mda = generalForm?.sent_to?.office || "";
    generalForm.sent_to_office = generalForm.sent_to.title || "";
    form.query_type = "insert";
    form.approval_type = "Capital";
    form.approved_by = "HE";
    form.approval_status = "Approval Released";
    form.send_to_mda = form.mda_code;
    form.cc = generalForm.cc;
    form.cc_mda_name = generalForm.cc_mda_name;
    postApi(`post_approval_collection`, { form })
      .then((data) => {
        if (data.success) {
          console.log(data);
          handleApi1(form.approval_no);
          // handleSubmitReset();
          alert("submit success");
          // setShowForm(false);
          postApi(`planning-reservation`, {
            // ...form,
            destMdaCode: form.mda_code,
            destEconomicCode: form.economic_code,
            destMdaDescription: form.mda_name,
            destEconomicDescription: form.description,
            destFundCode: form.fund_code,
            destFundDescription: form.fund_description,
            destFunctionalCode: form.functional_code,
            destFunctionalDescription: form.functional_description,
            destProgramCode: form.program_code,
            destProgramDescription: form.program_description,
            destGeoCode: form.geo_code,
            destGeoDescription: form.geo_description,
            approvedAmount: form.approved_amount,
            query_type: "insert",
            reserveStatus: "Pending",
            approvalNo: form.approval_no,
          })
            .then((data) => {
              if (data.success) {
                console.log(data);
                alert("submit success");
                // setShowForm(false);
                navigate("/planning-reservation");
              }
            })
            .catch((err) => {
              alert(err);
            })
            .finally(() => {
              setSubmittingReserveRequest(false);
            });
        }
      })
      .catch((err) => {
        alert(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {/* {JSON.stringify(form)} */}
      {showForm ? (
        <Row className="m-3">
          <Col md={4}>
            <Label>Date</Label>
            <Input
              type="date"
              value={form.approval_date}
              name="approval_date"
              onChange={handleChange}
            />
          </Col>
          {/* <Col md={4}>
            <Label>PV Number</Label>
            <Input
              type="number"
              value={form.pv_code}
              name="pv_code"
              onChange={handleChange}
            />
          </Col> */}
          {/* <Col md={4}> */}
          {/* <Label>Project Type</Label>
            <Input
              id="exampleSelect"
              value={form.projectType}
              name="projectType"
              type="select"
              onChange={handleChange}
            >
              <option>--Select--</option>
              <option value="Special Project">Special Project</option>
              <option value="Constituency Project">Constituency Project</option>
              <option value="Other">Other</option>
            </Input> */}
          {/* </Col> */}
          {/* {form.projectType === "Other" && (
            <Col md={4}>
              <Label>Enter Project Type</Label>
              <Input
                type="text"
                value={form.other_project_type}
                name="other_project_type"
                onChange={handleChange}
              />
            </Col>
          )} */}
          {/* <Col md={4}>
            <Label>Payment Type</Label>
            <Input
              id="exampleSelect"
              value={form.paymentType}
              name="paymentType"
              type="select"
              onChange={handleChange}
            >
              <option>--Select--</option>
              <option value="Direct Payment">Direct Payment</option>
              <option value="Power of Attorney">Power of Attorney</option>
              <option value="Other">Other</option>
            </Input>
          </Col> */}
          {/* {form.paymentType === "Other" && (
            <Col md={4}>
              <Label>Enter Payment Type</Label>
              <Input
                type="text"
                value={form.other_payment_type}
                name="other_payment_type"
                onChange={handleChange}
              />
            </Col>
          )} */}
          {/* <Col md={4}>
            <Label>Payment Class</Label>
            <Typeahead
              size="sm"
              id="20"
              onChange={(selected) => {
                if (selected && selected.length) {
                  setForm((p) => ({
                    ...p,
                    paymentClass: selected[0].economic_description,
                  }));
                }
              }}
              options={getDistinctObjects(
                economicCode,
                "economic_code",
                "economic_description"
              )}
              labelKey={(option) =>
                // ${option.economic_code} -
                `${option.economic_description}`
              }
              placeholder="Select---"
            /> */}
          {/* <Input
              id="exampleSelect"
              value={form.paymentClass}
              name="paymentClass"
              type="select"
              onChange={handleChange}
            >
              <option>--Select--</option>
              <option value="Certificate Number">Certificate Number</option>
              <option value="APG Number">APG Number</option>
              <option value="Mobilization">Mobilization</option>
              <option value="Retention">Retention</option>
              <option value="Land and Building">Land and Building</option>
              <option value="Plant and Machinery">Plant and Machinery</option>
              <option value="Furniture and Fittings">
                Furniture and Fittings
              </option>
              <option value="other">Other</option>
            </Input> */}
          {/* </Col> */}
          {/* {JSON.stringify(form)} */}
          <Col md={4}>
            <Label>Select MDA</Label>
            <Typeahead
              size="sm"
              id="20"
              onChange={(selected) => handleMdaCode1(selected)}
              onInputChange={(text) => console.log(text)}
              options={distinctAdmins.length ? distinctAdmins : []}
              // options={budgetSummary.length ? budgetSummary : []}
              labelKey={(option) => `${option.admin_description}`}
              placeholder="Select---"
              ref={mdaRef}
            />
            {fetching && <Spinner size={"sm"} />}
          </Col>
          <Col md={4}>
            <Label>Admin Code</Label>
            <Input
              type="text"
              value={form.mda_code}
              // name="sourceMdaCode"
              // onChange={handleChange}
              disabled
            />
          </Col>
          <Col md={4}>
            <Label>
              Select Head (if any){" "}
              <span
                style={{
                  // backgroundColor: "green",
                  borderRadius: 10,
                }}
                className="p-2 bg-success text-white"
              >
                OR {" PAYABLE TO "}{" "}
                <Input
                  id="checkbox3"
                  type="checkbox"
                  style={{ fontSize: 15, marginBottom: 10 }}
                  name="projectType"
                  value="payable-to"
                  checked={form.projectType === "payable-to"}
                  onChange={handleChanges}
                />
              </span>
            </Label>
            <Typeahead
              size="sm"
              id="20"
              onChange={(selected) => handleMdaCode(selected)}
              // onInputChange={(text) => console.log(text)}
              options={distinctAdmins.length ? distinctAdmins : []}
              labelKey={(option) => `${option.admin_description}`}
              placeholder="Select---"
              // ref={mdaRef}
            />
          </Col>
          <Col md={4}>
            <Label>Select Economic Code</Label>
            <Typeahead
              size="sm"
              id="20"
              onChange={(selected) => handleEconomicCode(selected)}
              options={getDistinctObjects(
                filteredEconomicCode.filter(
                  (item) =>
                    item.economic_code &&
                    item.economic_description &&
                    item.economic_code.trim() !== "" &&
                    item.economic_description.trim() !== "",
                ),
                "economic_code",
                "economic_description",
              )}
              labelKey={(option) =>
                `${option.economic_description} - ${option.economic_code}`
              }
              placeholder="Select---"
              ref={ecoRef}
            />
          </Col>

          <Col md={4}>
            <Label>Select Fund Code</Label>
            <Typeahead
              size="sm"
              id="20"
              ref={fundRef}
              onChange={(selected) => {
                if (selected && selected.length) {
                  handleChange({
                    target: { name: "fund_code", value: selected[0].fund_code },
                  });
                  setForm((p) => ({
                    ...p,
                    fund_description: selected[0].fund_description,
                  }));
                }
              }}
              options={getDistinctObjects(
                filteredEconomicCode.filter(
                  (item) =>
                    item.fund_code &&
                    item.fund_description &&
                    item.fund_code.trim() !== "" &&
                    item.fund_description.trim() !== "",
                ),
                "fund_code",
                "fund_description",
              )}
              labelKey={(option) =>
                `${option.fund_code}/${option.fund_description}`
              }
              placeholder="Select---"
            />
          </Col>

          <Col md={4}>
            <Label>Select Functional Code</Label>
            <Typeahead
              size="sm"
              id="20"
              ref={functionalRef}
              onChange={(selected) => {
                if (selected && selected.length) {
                  handleChange({
                    target: {
                      name: "functional_code",
                      value: selected[0].functional_code,
                    },
                  });
                  setForm((p) => ({
                    ...p,
                    functional_description: selected[0].functional_description,
                  }));
                }
              }}
              options={getDistinctObjects(
                filteredEconomicCode.filter(
                  (item) =>
                    item.functional_code &&
                    item.functional_description &&
                    item.functional_code.trim() !== "" &&
                    item.functional_description.trim() !== "",
                ),
                "functional_code",
                "functional_description",
              )}
              labelKey={(option) =>
                `${option.functional_code}/${option.functional_description}`
              }
              placeholder="Select---"
            />
          </Col>

          <Col md={4}>
            <Label>Select Program Code</Label>
            <Typeahead
              size="sm"
              id="20"
              ref={programRef}
              onChange={(selected) => {
                if (selected && selected.length) {
                  handleChange({
                    target: {
                      name: "program_code",
                      value: selected[0].program_code,
                    },
                  });
                  setForm((p) => ({
                    ...p,
                    program_description: selected[0].program_description,
                  }));
                }
              }}
              options={getDistinctObjects(
                filteredEconomicCode.filter(
                  (item) =>
                    item.program_code &&
                    item.program_description &&
                    item.program_code.trim() !== "" &&
                    item.program_description.trim() !== "",
                ),
                "program_code",
                "program_description",
              )}
              labelKey={(option) =>
                `${option.program_code}/${option.program_description}`
              }
              placeholder="Select---"
            />
          </Col>

          <Col md={4}>
            <Label>Select Geo Code</Label>
            <Typeahead
              size="sm"
              id="20"
              ref={geoRef}
              onChange={(selected) => {
                if (selected && selected.length) {
                  handleChange({
                    target: { name: "geo_code", value: selected[0].geo_code },
                  });
                  setForm((p) => ({
                    ...p,
                    geo_description: selected[0].geo_description,
                  }));
                }
              }}
              options={getDistinctObjects(
                filteredEconomicCode.filter(
                  (item) =>
                    item.geo_code &&
                    item.geo_description &&
                    item.geo_code.trim() !== "" &&
                    item.geo_description.trim() !== "",
                ),
                "geo_code",
                "geo_description",
              )}
              labelKey={(option) =>
                `${option.geo_code}/${option.geo_description}`
              }
              placeholder="Select---"
            />
          </Col>
          <Col md={4}>
            <Label>Approved Budget Allocation</Label>
            <Input
              value={formatNumber(form.mda_budget_balance)}
              name="mda_budget_balance"
              onChange={handleChange}
              disabled
            />
            {balLoanding && <Spinner size={"sm"} color="success" />}
          </Col>
          <Col md={4}>
            <Label>Budget Balance</Label>
            <Input
              value={formatNumber(form.mda_budget_balance)}
              name="mda_budget_balance"
              onChange={handleChange}
              disabled
            />
          </Col>

          <Col md={4}>
            <Label>Amount {formatNumber(form.approved_amount)}</Label>
            <Input
              type="number"
              value={form.approved_amount}
              name="approved_amount"
              onChange={handleChange}
            />
          </Col>
          <Col md={4}>
            <Label>Reference No</Label>
            <Input
              value={form.approval_no}
              name="approval_no"
              onChange={handleChange}
              type="text"
            />
          </Col>
          {form.economic_code !== "" && form.mda_budget_balance === 0 ? (
            <Alert color="primary" className="mt-2">
              <center>Please select the corresponding line item</center>
            </Alert>
          ) : null}

          <Col md={12}>
            <Label>Narration</Label>
            <div
              className="coloum"
              style={{
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "5px",
              }}
            >
              <Input
                className="coloum"
                type="textarea"
                value={form.narration}
                name="narration"
                onChange={handleChange}
                rows={5}
              />
            </div>
          </Col>

          <Col md={12} className="py-4 px-4">
            {/* <Attachment
              acceptedFiles={acceptedFiles}
              getRootProps={getRootProps}
              getInputProps={getInputProps}
              isDragActive={isDragActive}
            /> */}
          </Col>
          {/* <Row>
            <ContractorBankDetails form={form} setForm={setForm} />
          </Row> */}
          <Col md={12}>
            <center>
              <Button
                className="mb-4"
                onClick={isLoading ? "" : handleApi}
                disabled={isLoading}
              >
                {isLoading ? "Please wait..." : "Submit"}
              </Button>
            </center>
          </Col>

          <WarningModal
            showModal={showAmountWarningModal}
            setShowModal={setShowAmountWarningModal}
            handleSubmit={submitPlanningReserveRequest}
            form={form}
            loading={submittingReserveRequest}
          />
        </Row>
      ) : (
        <RealiseCollectionPdfWebView
          form={form}
          selecOffer={formatNumber}
          user={user}
        />
      )}
    </>
  );
}
